import * as react_components from "../reactcomponent.js"
import * as common_components from "../editor_common_components.js"
import { Innosoft_InnoBI_Controllers_ApiBuilderController as ApiBuilderController } from "../generated_api/generated_api.js"
import { Button } from "../../core/components/button.js";
import { Dialog, DialogProps } from "../../core/components/dialog.js";
import React from "react";
export class TemplateEditorControl extends React.Component<any, any>{
    constructor(props) {
        super(props);
        this.state = { showServiceSelector: false };
    }

    handleShowServiceSelector = () => {
        this.setState({ showServiceSelector: true });
    }

    handleClose = () => {
        this.setState({ showServiceSelector: false });
    }

    handleSave = (name) => {
        this.props.onTextChange(name);
        this.setState({ showServiceSelector: false });
    }

    render() {
        let editor;
        if (this.state.showServiceSelector === true) {
            editor = <TemplateEditorDialog onClose={this.handleClose} onSave={this.handleSave} value={this.props.value} />
        }
        return (
            <li>
                {editor}
                <div title={this.props.label}>
                    <span className="property-name">
                        <common_components.RightFloatingButtonScalor>
                            <Button iconName="edit" title="Edit" handleClick={this.handleShowServiceSelector} ></Button>
                        </common_components.RightFloatingButtonScalor>
                        {this.props.label}
                    </span>
                    <div className="c" style={{ "whiteSpace": "nowrap" }}>{this.props.value}

                    </div>
                </div>
            </li>
        );
    }
};

class TemplateEditorDialog extends React.Component<any, any>{

    constructor(props) {
        super(props);
        this.state = { value: props.value };
    }

    UNSAFE_componentWillMount() {
        new ApiBuilderController().GetAllServices((result) => {
            this.setState({ services: result });
        });
    }

    handleClose = () => {
        this.props.onClose();
    }

    handleSave = () => {
        this.props.onSave(this.state.value);
    }

    handleSourceCodeChanged = (e) => {
        this.setState({ value: e.target.value });
    }

    render() {
        return (<react_components.BasicDialog title="Edit template" onSave={this.handleSave} onClose={this.handleClose}>
            <div style={{ height: "500px" }}>
                <textarea style={{ height: "100%", width: "100%", resize: "none" }} onBlur={this.handleSourceCodeChanged}>{this.props.value}</textarea>
            </div>
        </react_components.BasicDialog>);
    }
};

export class UiBuilderMemoEditor extends React.Component<{ onClose, onSave, value }, any>{
    private textArea: HTMLTextAreaElement;

    private dialogProps: DialogProps = {
        title: "Change text",
        actions: [
            {
                label: "Cancel",
                action: () => {
                    this.props.onClose();
                    return true;
                }
            },
            {
                label: "Save",
                action: () => {
                    this.props.onSave(this.textArea.value)
                },
                primary: true
            }],
        afterClose: () => {
        },
        width: 500,
        open: true
    }

    render() {
        var style = { height: '500px' };
        return (<Dialog {...this.dialogProps}>
            <textarea style={{ width: "98%", height: "250px" }} ref={(element) => this.textArea = element} defaultValue={this.props.value}></textarea>
        </Dialog>

        );
    }
};